import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, BookOpen, Book, Printer, Camera, Megaphone } from "lucide-react";
import { trackPageView } from "../lib/api";

const UNION_BOT_AVATAR = "/kevin-bradshaw.jpg?v=2";

/** Bottom mobile nav bar (md:hidden) */
export const MobileBottomNav = () => {
  const location = useLocation();
  const path = location.pathname;

  const navItems = [
    { to: "/", icon: Home, label: "Home", match: "/" },
    { to: "/learn", icon: BookOpen, label: "Learn", match: "/learn" },
    { to: "/book", icon: Book, label: "Book", match: "/book" },
    { to: "/print-shop", icon: Printer, label: "Print", match: "/print-shop" },
    { to: "/gallery", icon: Camera, label: "Gallery", match: "/gallery" },
    { to: "/strikes", icon: Megaphone, label: "Strikes", match: "/strikes" },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-[9998] bg-white border-t border-slate-200 shadow-[0_-2px_10px_rgba(0,0,0,0.08)]" data-testid="mobile-bottom-nav">
      <div className="flex items-center justify-around h-14">
        {navItems.map(item => {
          const Icon = item.icon;
          const active = item.match === "/" ? path === "/" : path.startsWith(item.match);
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${active ? "text-red-600" : "text-slate-400 hover:text-slate-600"}`}
              data-testid={`mobile-nav-${item.label.toLowerCase().replace(' ', '-')}`}
            >
              <Icon className="w-5 h-5" />
              <span className="text-[10px] mt-0.5 font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

/** Scroll to top on route change + track page view */
export const ScrollToTop = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(location.pathname);
  }, [location.pathname]);
  return null;
};

export { UNION_BOT_AVATAR };
